/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Tab_Token_PoolInputs */



/**
* | output |
* | --- |
* | "Token pool" |
*
* @param {Plan_Tab_Token_PoolInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_token_pool = /** @type {((inputs?: Plan_Tab_Token_PoolInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Token_PoolInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Token-Pool")
	return /** @type {LocalizedString} */ ("Token pool")
});